// extracted by mini-css-extract-plugin
export default {"container":"OrganizationSelectPage_container__O7t1w","header":"OrganizationSelectPage_header__kBVcB"};